export default {
  path: '/add_transfers_to_runs',
  name: 'add_transfers_to_runs',
  component: () => import('../components/addtransferstorun/Layout'),
  redirect: { name: 'AddTransfersToRunList' },
  children: [
    {
      name: 'AddTransfersToRunList',
      path: '',
      component: () => import('../views/addtransferstorun/List')
    },
    {
      name: 'AddTransfersToRunCreate',
      path: ':id/new',
      component: () => import('../views/addtransferstorun/Create')
    }
  ]
};
